import type { CSSObject } from '@emotion/react'
import { Color, FocusIndicator, Size, Spacing, Typography } from '@opallabs/gem'
import type { WithRequiredTheme } from '@opallabs/lapidary'

// This file has styling for using Kuiper `<Menu>` in combination with Lapidary
// `<Popover>`--controlled by the `disableKuiperStyling` prop.

const row: CSSObject = {
  boxSizing: 'border-box',
  display: 'flex',
}

type ContainerProps = WithRequiredTheme
export const container = ({ theme }: ContainerProps): CSSObject => ({
  ...row,
  borderRadius: Size.Rounding / 2,
  cursor: 'pointer',
  color: Color[theme].Text.Default,

  '&:focus': {
    ...FocusIndicator[theme],
  },
  '&:focus, &:hover': {
    backgroundColor: Color[theme].Surface.N200,
  },
  '&[aria-current=true], &[aria-selected=true]': {
    backgroundColor: Color[theme].Translucent.A36,
  },

  '.kuiper-token': {
    ...Typography.T500,
    ...row,
    backgroundColor: 'transparent',
    color: 'inherit',
    cursor: 'inherit',
    flexGrow: 1,
    margin: 0,
    maxInlineSize: 'initial',
    minBlockSize: Spacing.L * 1.5,
    paddingBlock: Spacing.XS * 1.5,
    paddingInline: Spacing.S * 1.5,

    '&.kuiper-selected': {
      backgroundColor: 'transparent',
      color: 'inherit',
    },

    '.kuiper-title': {
      cursor: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
      margin: 'initial',
      padding: 'initial',
      position: 'static',
      textAlign: 'start',
      whiteSpace: 'initial',
    },
  },
})
